import { displayToast } from "../../../../helpers/notification";
import { AdminSettingTypes as Type } from "../../../types/adminsetting";


export function getAdminListRequest(body: any) {
  return {
    type: Type.GET_ADMIN_LIST_REQUEST,
    body: body
  };
}

export function getAdminListRequestSuccess(data: any) {
  return {
    type: Type.GET_ADMIN_LIST_REQUEST_SUCCESS,
    payload: data,
  };
}

export function getAdminListRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.GET_ADMIN_LIST_REQUEST_FAILURE,
    error: error,
  };
}